import { __read } from "tslib";
import { COLOR } from '../groups';
import { rgbToHex, N0, N80, P50, P300, P500, T75, T300, T500, G75, G300, G500, R75, R300, R500, Y75, Y200, Y400, B75, B100, B500, } from '../../utils/colors';
var colorArrayPalette = [
    // default row
    // [N800, default],
    [N80, 'Light gray'],
    [P300, 'Purple'],
    [T300, 'Teal'],
    [G300, 'Green'],
    [R300, 'Red'],
    [Y400, 'Orange'],
];
// ED-8368: used for A/B testing of text color picker
var colorArrayPaletteExperimental = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [B100, 'Blue'],
    [T300, 'Teal'],
    [G300, 'Green'],
    [Y200, 'Yellow'],
    [R300, 'Red'],
    [P300, 'Purple'],
    // row 2
    [N80, 'Light gray'],
    [B500, 'Dark blue'],
    [T500, 'Dark teal'],
    [G500, 'Dark green'],
    [Y400, 'Orange'],
    [R500, 'Dark red'],
    [P500, 'Dark purple'],
    // row 3
    [N0, 'White'],
    [B75, 'Light blue'],
    [T75, 'Light teal'],
    [G75, 'Light green'],
    [Y75, 'Light yellow'],
    [R75, 'Light red'],
    [P50, 'Light purple'],
];
// @see https://product-fabric.atlassian.net/wiki/spaces/E/pages/55979455/Colour+picker+decisions#Colourpickerdecisions-Visualdesigndecisions
export var colorPalette = new Map();
export var colorPaletteExperimental = new Map();
colorArrayPalette.forEach(function (_a) {
    var _b = __read(_a, 2), color = _b[0], label = _b[1];
    return colorPalette.set(color.toLowerCase(), label);
});
colorArrayPaletteExperimental.forEach(function (_a) {
    var _b = __read(_a, 2), color = _b[0], label = _b[1];
    return colorPaletteExperimental.set(color.toLowerCase(), label);
});
export var textColor = {
    attrs: { color: {} },
    inclusive: true,
    group: COLOR,
    parseDOM: [
        {
            style: 'color',
            getAttrs: function (maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) {
                    hexColor = rgbToHex(value);
                }
                else if (value[0] === '#') {
                    hexColor = value.toLowerCase();
                }
                // else handle other colour formats
                return hexColor &&
                    (colorPalette.has(hexColor) || colorPaletteExperimental.has(hexColor))
                    ? { color: hexColor }
                    : false;
            },
        },
    ],
    toDOM: function (mark) {
        return [
            'span',
            {
                style: "color: " + mark.attrs.color,
            },
        ];
    },
};
//# sourceMappingURL=text-color.js.map